import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MessageCircle, HelpCircle } from 'lucide-react';

export default function Contact() {
  return (
    <div className="min-h-screen bg-qc-bg text-qc-text">
      <div 
        className="px-5 py-3 flex items-center max-w-2xl mx-auto"
        style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top, 0px))' }}
      >
        <Link
          to="/login"
          data-testid="contact-back-button"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-qc-surface border border-qc-border text-qc-text"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <h1 className="text-base font-extrabold text-qc-text ml-3">Contact</h1>
      </div>

      <div className="max-w-2xl mx-auto px-5 py-6" data-testid="contact-page">
        <h1 className="text-3xl font-black text-qc-text mb-3">Get in Touch</h1>
        <p className="text-qc-text-dim mb-8">
          Have questions, feedback, or need help? We&apos;re here for you.
        </p>

        <div className="space-y-4">
          {/* General Support */}
          <div className="bg-qc-surface rounded-2xl border border-qc-border p-5">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-qc-green/15 border border-qc-green/30 flex items-center justify-center flex-shrink-0">
                <HelpCircle className="w-6 h-6 text-qc-green" />
              </div>
              <div>
                <h2 className="text-lg font-bold text-qc-text mb-1">General Support</h2>
                <p className="text-sm text-qc-text-dim mb-3">
                  Questions about your account, subscription, or how to use Green Light.
                </p>
                <a 
                  href="mailto:support@getgreenlight.app" 
                  className="text-qc-green font-bold text-sm hover:text-qc-green-dark"
                  data-testid="support-email-link"
                >
                  support@getgreenlight.app
                </a>
              </div>
            </div>
          </div>

          {/* Feedback */}
          <div className="bg-qc-surface rounded-2xl border border-qc-border p-5">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-qc-amber/15 border border-qc-amber/30 flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-6 h-6 text-qc-amber" />
              </div>
              <div>
                <h2 className="text-lg font-bold text-qc-text mb-1">Feedback & Suggestions</h2>
                <p className="text-sm text-qc-text-dim mb-3">
                  Ideas to make Green Light better? We&apos;d love to hear them.
                </p>
                <a 
                  href="mailto:feedback@getgreenlight.app" 
                  className="text-qc-amber font-bold text-sm hover:text-qc-amber/80"
                  data-testid="feedback-email-link"
                >
                  feedback@getgreenlight.app
                </a>
              </div>
            </div>
          </div>

          {/* Business */}
          <div className="bg-qc-surface rounded-2xl border border-qc-border p-5">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-qc-surface2 border border-qc-border flex items-center justify-center flex-shrink-0">
                <Mail className="w-6 h-6 text-qc-text-dim" />
              </div>
              <div>
                <h2 className="text-lg font-bold text-qc-text mb-1">Business Inquiries</h2>
                <p className="text-sm text-qc-text-dim mb-3">
                  Partnership opportunities, press, or business development.
                </p>
                <a 
                  href="mailto:hello@getgreenlight.app" 
                  className="text-qc-text font-bold text-sm hover:text-qc-text-dim"
                  data-testid="business-email-link"
                >
                  hello@getgreenlight.app
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Response Time */}
        <div className="mt-8 p-4 bg-qc-surface2 rounded-xl border border-qc-border">
          <p className="text-sm text-qc-text-dim text-center">
            We typically respond within <span className="text-qc-text font-bold">24-48 hours</span> on business days.
          </p>
        </div>
      </div>
    </div>
  );
}
